export const CONFIG_DEFAULTS = {
  defaultContrastMinimum: 4.5,
  defaultContrastMaximum: 10,
}